var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOsint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22.5,
    r: 22,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6659 18.5C28.6659 17.7636 29.2628 17.1667 29.9992 17.1667C30.7356 17.1667 31.3325 17.7636 31.3325 18.5C31.3325 19.2364 30.7356 19.8333 29.9992 19.8333C29.2628 19.8333 28.6659 19.2364 28.6659 18.5Z",
    fill: "#0B0B17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9992 23.8333C25.2628 23.8333 24.6659 24.4303 24.6659 25.1667C24.6659 25.903 25.2628 26.5 25.9992 26.5C26.7356 26.5 27.3325 25.903 27.3325 25.1667C27.3325 24.4303 26.7356 23.8333 25.9992 23.8333Z",
    fill: "#0B0B17"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3328 27.8333C33.5419 27.8333 35.3327 26.0425 35.3327 23.8334L35.3329 17.1667C35.3329 14.9576 33.542 13.1667 31.3329 13.1667H24.4373C24.0836 13.1667 23.7445 13.0262 23.4944 12.7761L22.3899 11.6716C21.6397 10.9214 20.6223 10.5 19.5614 10.5H16.666C14.4569 10.5 12.666 12.2909 12.666 14.5L12.666 17.1667C10.4569 17.1667 8.66602 18.9575 8.66602 21.1667V30.5C8.66602 32.7091 10.4569 34.5 12.666 34.5H27.3327C29.5418 34.5 31.3327 32.7092 31.3327 30.5001L31.3328 27.8333ZM20.5043 13.5572C20.2542 13.3071 19.9151 13.1667 19.5614 13.1667H16.666C15.9296 13.1667 15.3327 13.7636 15.3327 14.5V17.1667H15.5614C16.6223 17.1667 17.6397 17.5881 18.3899 18.3382L19.4944 19.4428C19.7445 19.6929 20.0836 19.8333 20.4373 19.8333H27.3329C29.542 19.8333 31.3329 21.6242 31.3329 23.8334L31.3328 25.1667C32.0692 25.1666 32.6661 24.5697 32.6661 23.8334L32.6662 17.1667C32.6662 16.4303 32.0693 15.8333 31.3329 15.8333H24.4373C23.3764 15.8333 22.359 15.4119 21.6088 14.6618L20.5043 13.5572ZM16.5043 20.2239C16.2542 19.9738 15.9151 19.8333 15.5614 19.8333H12.666C11.9296 19.8333 11.3327 20.4303 11.3327 21.1667V30.5C11.3327 31.2364 11.9296 31.8333 12.666 31.8333H27.3327C28.0691 31.8333 28.6661 31.2364 28.6661 30.5L28.6662 23.8334C28.6662 23.097 28.0693 22.5 27.3329 22.5H20.4373C19.3764 22.5 18.359 22.0786 17.6088 21.3284L16.5043 20.2239Z",
    fill: "#0B0B17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOsint);
export default __webpack_public_path__ + "static/media/osint.3e8b64d333529d10706c1d0376ced61a.svg";
export { ForwardRef as ReactComponent };